// extracted by mini-css-extract-plugin
module.exports =  {"small-label":"QLDeThGKkiclK0c6B47jq"};